import React from 'react'
import { useDispatch } from 'react-redux'
import { Formik } from 'formik'
import {
    Button,
    Input,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    Form,
    Label,
    FormGroup,
} from 'reactstrap'
import { getOrgVehiclePage, resetVehicles } from 'features/dashboard/Vehicle.actionTypes'
import {
    getOrgDeviceModels,
    getOrgSetups,
    resetDeviceModels,
    resetSetups,
} from 'features/dashboard/RosSetup.actionTypes'
import { deviceModelTypes } from 'components/dashboard-components/organization/OrgTeamHelpers'
import {
    getActionsPresets,
    getPresetTasksV2,
    resetActionsPresets,
    resetPresetTasksV2,
} from 'features/dashboard/Task.actionTypes'
import { getAuditLogsLight, resetAuditLogs } from 'features/dashboard/Organization.actionTypes'
import { getFilterDashboard, resetDashboard } from 'features/dashboard/TeamAnalytics.actionTypes'

const event_types_logs = [
    'user-login',
    'user-login-failed',
    'user-api-token-created',
    'site-sync-api-token-created',
    'site-sync-api-token-deleted',
    'reset-access',
    'reset-user-access',
    'changed-user-access',
    'vehicle-added-to-fleet',
    'vehicle-removed-from-fleet',
    'map-uploaded',
    'cad-map-uploaded',
    'ros-setup-created',
    'ros-setup-deleted',
    'ros-setup-used',
    'vehicle-access-granted',
    'vehicle-access-revoked',
    'vehicle-created',
    'vehicle-changed',
    'emergency-stop-triggered',
    'emergency-stop-resumed',
    'webhook-created',
    'webhook-deleted',
    'trigger-created',
    'trigger-updated',
]

const Filter = ({
    slug,
    initValues,
    setInitValues,
    dropdownOpen,
    toggle,
    table,
    teams,
    stations,
    categories,
    activeTab,
    setLastClickedPage,
    setCurrentPageNumber,
    selectedDateRange,
    vehicles,
    dashboardUuid,
    from_date,
    to_date,
}) => {
    const dispatch = useDispatch()
    const resetActions = {
        dashboard: resetDashboard,
        devices: resetDeviceModels,
        vehicles: resetVehicles,
        actions: activeTab === 'presets' ? resetPresetTasksV2 : resetActionsPresets,
        setups: resetSetups,
        audit_logs: resetAuditLogs,
    }
    const dispatchActions = {
        dashboard: getFilterDashboard,
        vehicles: getOrgVehiclePage,
        devices: getOrgDeviceModels,
        actions: activeTab === 'presets' ? getPresetTasksV2 : getActionsPresets,
        setups: getOrgSetups,
        audit_logs: getAuditLogsLight,
    }

    const handleSubmit = (values) => {
        const resetAction = resetActions[table]
        const dispatchAction = dispatchActions[table]

        if (resetAction && dispatchAction) {
            toggle()
            dispatch(resetAction())

            if (table === 'audit_logs') {
                return dispatch(
                    dispatchAction({ slug, filters: values, dateRange: selectedDateRange })
                )
            }

            if (table === 'dashboard') {
                return dispatch(
                    dispatchAction({
                        slug,
                        uuid: dashboardUuid,
                        from_date,
                        to_date,
                        vehicle_categories: values.vehicle_categories,
                        vehicles: values.vehicles,
                    })
                )
            }

            setCurrentPageNumber(1)
            setLastClickedPage(0)

            return dispatch(dispatchAction({ slug, filters: values }))
        }

        return null
    }

    const cancelValues = () => {
        switch (table) {
            case 'vehicles':
                return setInitValues({
                    team: [],
                    category: [],
                    status: '',
                })
            case 'devices':
                return setInitValues({
                    team: [],
                    device_model_type: [],
                })
            case 'actions':
                return setInitValues({ stations: [] })
            case 'audit_logs':
                return setInitValues({ event_type: [], team: [] })
            case 'dashboard':
                return setInitValues({ vehicle_categories: [], vehicles: [] })
            default:
                return setInitValues({
                    team: [],
                    type: [],
                })
        }
    }

    const renderFilters = (values, setFieldValue) => {
        switch (table) {
            case 'dashboard':
                return (
                    <>
                        {' '}
                        <div style={{ width: '200px', }}>
                            <div className="filter-heading pt-3">Category</div>
                            {categories.map((category) => (
                                <FormGroup check key={category.uuid} className='ml-1'>
                                    <Input
                                        key={category.uuid}
                                        type="checkbox"
                                        name="category"
                                        checked={initValues.vehicle_categories.includes(
                                            category.uuid
                                        )}
                                        id={category.title}
                                        value={category.uuid}
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.vehicle_categories.includes(value))
                                                    return
                                                setFieldValue('vehicle_categories', [
                                                    ...values.vehicle_categories,
                                                    value,
                                                ])
                                                setInitValues({
                                                    ...values,
                                                    vehicle_categories: [
                                                        ...values.vehicle_categories,
                                                        value,
                                                    ],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'vehicle_categories',
                                                    values.vehicle_categories.filter(
                                                        (category) => category !== value
                                                    )
                                                )
                                                setInitValues({
                                                    ...values,
                                                    vehicle_categories:
                                                        values.vehicle_categories.filter(
                                                            (category) => category !== value
                                                        ),
                                                })
                                            }
                                        }}
                                    />

                                    <Label check>{category.title}</Label>
                                </FormGroup>
                            ))}

                            <FormGroup check className='ml-1'>
                                <Input
                                    type="checkbox"
                                    name="null"
                                    checked={initValues.vehicle_categories.includes('null')}
                                    id="null"
                                    value={'null'}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked

                                        if (isChecked) {
                                            setFieldValue('vehicle_categories', [
                                                ...values.vehicle_categories,
                                                'null',
                                            ])
                                            setInitValues({
                                                ...values,
                                                vehicle_categories: [
                                                    ...values.vehicle_categories,
                                                    'null',
                                                ],
                                            })
                                        } else {
                                            setFieldValue(
                                                'vehicle_categories',
                                                values.vehicle_categories.filter(
                                                    (category) => category !== 'null'
                                                )
                                            )
                                            setInitValues({
                                                ...values,
                                                vehicle_categories:
                                                    values.vehicle_categories.filter(
                                                        (category) => category !== 'null'
                                                    ),
                                            })
                                        }
                                    }}
                                />
                                <Label check>Unassigned</Label>
                            </FormGroup>
                        </div>
                        <div style={{ width: '200px'}}>
                        <div className="filter-heading pt-3">Vehicle</div>
                            {vehicles.map((veh) => (
                                <FormGroup check key={veh.uuid} className='ml-1'>
                                    <Input
                                        key={veh.uuid}
                                        type="checkbox"
                                        name="vehicles"
                                        checked={initValues.vehicles.includes(veh.uuid)}
                                        id={veh.verbose_name}
                                        value={veh.uuid}
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.vehicles.includes(value)) return
                                                setFieldValue('vehicles', [
                                                    ...values.vehicles,
                                                    value,
                                                ])
                                                setInitValues({
                                                    ...values,
                                                    vehicles: [...values.vehicles, value],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'vehicles',
                                                    values.vehicles.filter(
                                                        (category) => category !== value
                                                    )
                                                )
                                                setInitValues({
                                                    ...values,
                                                    vehicles: values.vehicles.filter(
                                                        (category) => category !== value
                                                    ),
                                                })
                                            }
                                        }}
                                    />

                                    <Label check>{veh.verbose_name}</Label>
                                </FormGroup>
                            ))}

                            <FormGroup check className='ml-1'>
                                <Input
                                    type="checkbox"
                                    name="null"
                                    checked={initValues.vehicles.includes('null')}
                                    id="null"
                                    value={'null'}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked

                                        if (isChecked) {
                                            setFieldValue('vehicles', [...values.vehicles, 'null'])
                                            setInitValues({
                                                ...values,
                                                vehicles: [...values.vehicles, 'null'],
                                            })
                                        } else {
                                            setFieldValue(
                                                'vehicles',
                                                values.vehicles.filter((veh) => veh !== 'null')
                                            )
                                            setInitValues({
                                                ...values,
                                                vehicles: values.vehicles.filter(
                                                    (veh) => veh !== 'null'
                                                ),
                                            })
                                        }
                                    }}
                                />
                                <Label check>Unassigned</Label>
                            </FormGroup>
                        </div>
                    </>
                )
            case 'vehicles':
                return (
                    <>
                        <div style={{ width: '200px' }}>
                        <div className="filter-heading pt-3">Team</div>
                            {teams.map((team) => (
                                <FormGroup check key={team.uuid} className='ml-1'>
                                    <Input
                                        key={team.uuid}
                                        type="checkbox"
                                        id={team.slug}
                                        value={team.slug}
                                        checked={initValues.team.includes(team.slug)}
                                        name="team"
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.team.includes(value)) return
                                                setFieldValue('team', [...values.team, value])
                                                setInitValues({
                                                    ...values,
                                                    team: [...values.team, value],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'team',
                                                    values.team.filter((team) => team !== value)
                                                )
                                                setInitValues({
                                                    ...values,
                                                    team: values.team.filter(
                                                        (team) => team !== value
                                                    ),
                                                })
                                            }
                                        }}
                                    />
                                    <Label check> {team.title}</Label>
                                </FormGroup>
                            ))}
                            <FormGroup check>
                                <Input
                                    type="checkbox"
                                    name="null"
                                    checked={initValues.team.includes('null')}
                                    id="null"
                                    value={'null'}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked

                                        if (isChecked) {
                                            // Pass `null` when checked

                                            setFieldValue('team', [...values.category, 'null'])
                                            setInitValues({
                                                ...values,
                                                team: [...values.team, 'null'],
                                            })
                                        } else {
                                            setFieldValue(
                                                'team',
                                                values.team.filter((team) => team !== 'null')
                                            )
                                            setInitValues({
                                                ...values,
                                                team: values.team.filter((team) => team !== 'null'),
                                            })
                                        }
                                    }}
                                />
                                <Label check>Unassigned</Label>
                            </FormGroup>
                        </div>
                        <div style={{ width: '200px' }}>
                        <div className="filter-heading pt-3">Category</div>
                            {categories.map((category) => (
                                <FormGroup check key={category.uuid} className='ml-1'>
                                    <Input
                                        key={category.uuid}
                                        type="checkbox"
                                        name="category"
                                        checked={initValues.category.includes(category.title)}
                                        id={category.title}
                                        value={category.title}
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.category.includes(value)) return
                                                setFieldValue('category', [
                                                    ...values.category,
                                                    value,
                                                ])
                                                setInitValues({
                                                    ...values,
                                                    category: [...values.category, value],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'category',
                                                    values.category.filter(
                                                        (category) => category !== value
                                                    )
                                                )
                                                setInitValues({
                                                    ...values,
                                                    category: values.category.filter(
                                                        (category) => category !== value
                                                    ),
                                                })
                                            }
                                        }}
                                    />

                                    <Label check>{category.title}</Label>
                                </FormGroup>
                            ))}

                            <FormGroup check>
                                <Input
                                    type="checkbox"
                                    name="null"
                                    checked={initValues.category.includes('null')}
                                    id="null"
                                    value={'null'}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked

                                        if (isChecked) {
                                            setFieldValue('category', [...values.category, 'null'])
                                            setInitValues({
                                                ...values,
                                                category: [...values.category, 'null'],
                                            })
                                        } else {
                                            setFieldValue(
                                                'category',
                                                values.category.filter(
                                                    (category) => category !== 'null'
                                                )
                                            )
                                            setInitValues({
                                                ...values,
                                                category: values.category.filter(
                                                    (category) => category !== 'null'
                                                ),
                                            })
                                        }
                                    }}
                                />
                                <Label check>Unassigned</Label>
                            </FormGroup>
                        </div>
                        <div style={{ width: '200px' }}>
                        <div className="filter-heading pt-3">Status</div>
                            <FormGroup check className='ml-1'>
                                <Input
                                    type="checkbox"
                                    name="status"
                                    checked={
                                        values.status === 'active' || initValues.status === 'active'
                                    }
                                    id="active"
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setFieldValue('status', 'active')
                                            if (initValues.status === 'inactive') {
                                                setInitValues({ ...values, status: 'active' })
                                            } else {
                                                setInitValues({ ...values, status: 'active' })
                                            }
                                        }
                                    }}
                                />
                                <Label check className="mt-1">
                                    {' '}
                                    Active{' '}
                                </Label>
                            </FormGroup>
                            <FormGroup check className='ml-1'>
                                <Input
                                    type="checkbox"
                                    id="inactive"
                                    checked={
                                        values.status === 'inactive' ||
                                        initValues.status === 'inactive'
                                    }
                                    name="status"
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setFieldValue('status', 'inactive')
                                            if (initValues.status === 'active') {
                                                setInitValues({ ...values, status: 'inactive' })
                                            } else {
                                                setInitValues({ ...values, status: 'inactive' })
                                            }
                                        }
                                    }}
                                />
                                <Label check> Inactive</Label>
                            </FormGroup>
                        </div>
                    </>
                )
            case 'devices':
                return (
                    <>
                        <div style={{ width: '200px' }}>
                        <div className="filter-heading pt-3">Team</div>
                            {teams.map((team) => (
                                <FormGroup check key={team.uuid} className='ml-1'>
                                    <Input
                                        className="mt-2"
                                        key={team.uuid}
                                        type="checkbox"
                                        id={team.slug}
                                        value={team.slug}
                                        checked={initValues.team.includes(team.slug)}
                                        name="team"
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.team.includes(value)) return
                                                setFieldValue('team', [...values.team, value])
                                                setInitValues({
                                                    ...values,
                                                    team: [...values.team, value],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'team',
                                                    values.team.filter((team) => team !== value)
                                                )
                                                setInitValues({
                                                    ...values,
                                                    team: values.team.filter(
                                                        (team) => team !== value
                                                    ),
                                                })
                                            }
                                        }}
                                    />{' '}
                                    <Label check className="mt-1">
                                        {team.title}{' '}
                                    </Label>
                                </FormGroup>
                            ))}
                        </div>
                        <div style={{ width: '200px' }}>
                        <div className="filter-heading pt-3">Device model type</div>
                            {deviceModelTypes.map((type) => (
                                <FormGroup check key={type} className='ml-1'>
                                    <Input
                                        className="mt-2"
                                        key={type}
                                        type="checkbox"
                                        id={type}
                                        value={type}
                                        checked={initValues.device_model_type?.includes(type)}
                                        name="team"
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.device_model_type.includes(value))
                                                    return
                                                setFieldValue('device_model_type', [
                                                    ...values.device_model_type,
                                                    value,
                                                ])
                                                setInitValues({
                                                    ...values,
                                                    device_model_type: [
                                                        ...values.device_model_type,
                                                        value,
                                                    ],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'device_model_type',
                                                    values.device_model_type.filter(
                                                        (ty) => ty !== value
                                                    )
                                                )
                                                setInitValues({
                                                    ...values,
                                                    device_model_type:
                                                        values.device_model_type.filter(
                                                            (ty) => ty !== value
                                                        ),
                                                })
                                            }
                                        }}
                                    />
                                    <Label check className="mt-1">
                                        {type}{' '}
                                    </Label>
                                </FormGroup>
                            ))}
                        </div>
                    </>
                )
            case 'actions':
                return (
                    <div style={{ width: '200px' }}>
                        <div className="filter-heading pt-3">Stations</div>
                        {stations.map((station) => (
                            <FormGroup check key={station.uuid} className='ml-1'>
                                <Input
                                    className="mt-2"
                                    key={station.uuid}
                                    type="checkbox"
                                    id={station.uuid}
                                    value={station.uuid}
                                    checked={initValues.stations.includes(station.uuid)}
                                    name="stations"
                                    onChange={(e) => {
                                        const value = e.target.value
                                        const isChecked = e.target.checked
                                        if (isChecked) {
                                            if (initValues.stations.includes(value)) return
                                            setFieldValue('stations', [...values.stations, value])
                                            setInitValues({
                                                ...values,
                                                stations: [...values.stations, value],
                                            })
                                        } else {
                                            setFieldValue(
                                                'stations',
                                                values.stations.filter(
                                                    (station) => station !== value
                                                )
                                            )
                                            setInitValues({
                                                ...values,
                                                stations: values.stations.filter(
                                                    (station) => station !== value
                                                ),
                                            })
                                        }
                                    }}
                                />
                                <Label check className="mt-1">
                                    {station?.title}{' '}
                                </Label>
                            </FormGroup>
                        ))}
                    </div>
                )
            case 'audit_logs':
                return (
                    <>
                        <div style={{ width: '200px' }}>
                        <div className="filter-heading pt-3">Team</div>
                            {teams.map((team) => (
                                <FormGroup check key={team.uuid} className='ml-1'>
                                    <Input
                                        className="mt-2"
                                        key={team.uuid}
                                        type="checkbox"
                                        id={team.slug}
                                        value={team.slug}
                                        checked={initValues.team.includes(team.slug)}
                                        name="team"
                                        label={team.title}
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.team.includes(value)) return
                                                setFieldValue('team', [...values.team, value])
                                                setInitValues({
                                                    ...values,
                                                    team: [...values.team, value],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'team',
                                                    values.team.filter((team) => team !== value)
                                                )
                                                setInitValues({
                                                    ...values,
                                                    team: values.team.filter(
                                                        (team) => team !== value
                                                    ),
                                                })
                                            }
                                        }}
                                    />
                                    <Label check className="mt-1">
                                        {' '}
                                        {team.title}
                                    </Label>
                                </FormGroup>
                            ))}
                        </div>
                        <div style={{ width: '300px' }}>
                        <div className="filter-heading pt-3">Event type</div >
                            {event_types_logs
                                .sort((a, b) => a.localeCompare(b))
                                .map((type) => (
                                    <FormGroup check key={type} className='ml-1'>
                                        <Input
                                            key={type}
                                            type="checkbox"
                                            id={type}
                                            value={type}
                                            checked={initValues.event_type.includes(type)}
                                            name="event_type"
                                            label={type}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                const isChecked = e.target.checked
                                                if (isChecked) {
                                                    if (initValues.event_type.includes(value))
                                                        return
                                                    setFieldValue('event_type', [
                                                        ...values.event_type,
                                                        value,
                                                    ])
                                                    setInitValues({
                                                        ...values,
                                                        event_type: [...values.event_type, value],
                                                    })
                                                } else {
                                                    setFieldValue(
                                                        'event_type',
                                                        values.event_type.filter(
                                                            (type) => type !== value
                                                        )
                                                    )
                                                    setInitValues({
                                                        ...values,
                                                        event_type: values.event_type.filter(
                                                            (type) => type !== value
                                                        ),
                                                    })
                                                }
                                            }}
                                        />
                                        <Label check className="mt-1">
                                            {type}
                                        </Label>
                                    </FormGroup>
                                ))}
                        </div>
                    </>
                )

            default:
                return (
                    <>
                        <div style={{ width: '200px' }}>
                            <span className="text-black">Team</span>
                            {teams.map((team) => (
                                <FormGroup check key={team.uuid}>
                                    <Input
                                        className="mt-2"
                                        key={team.uuid}
                                        type="checkbox"
                                        id={team.slug}
                                        value={team.slug}
                                        checked={initValues.team.includes(team.slug)}
                                        name="team"
                                        label={team.title}
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.team.includes(value)) return
                                                setFieldValue('team', [...values.team, value])
                                                setInitValues({
                                                    ...values,
                                                    team: [...values.team, value],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'team',
                                                    values.team.filter((team) => team !== value)
                                                )
                                                setInitValues({
                                                    ...values,
                                                    team: values.team.filter(
                                                        (team) => team !== value
                                                    ),
                                                })
                                            }
                                        }}
                                    />
                                    <Label check className="mt-1">
                                        {' '}
                                        {team.title}
                                    </Label>
                                </FormGroup>
                            ))}
                        </div>
                        <div style={{ width: '200px' }}>
                            <span className="text-black">Type</span>
                            {['iot', 'robot'].map((type) => (
                                <FormGroup check key={type}>
                                    <Input
                                        className="mt-2"
                                        key={type}
                                        type="checkbox"
                                        id={type}
                                        value={type}
                                        checked={initValues.type.includes(type)}
                                        name="type"
                                        onChange={(e) => {
                                            const value = e.target.value
                                            const isChecked = e.target.checked
                                            if (isChecked) {
                                                if (initValues.type.includes(value)) return
                                                setFieldValue('type', [...values.type, value])
                                                setInitValues({
                                                    ...values,
                                                    type: [...values.type, value],
                                                })
                                            } else {
                                                setFieldValue(
                                                    'type',
                                                    values.type.filter((type) => type !== value)
                                                )
                                                setInitValues({
                                                    ...values,
                                                    type: values.type.filter(
                                                        (team) => team !== value
                                                    ),
                                                })
                                            }
                                        }}
                                    />
                                    <Label check className="mt-1">
                                        {' '}
                                        {type.charAt(0).toUpperCase() + type.slice(1)}
                                    </Label>
                                </FormGroup>
                            ))}
                        </div>
                    </>
                )
        }
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="left">
            <DropdownToggle
                outline
                id="filterId"
                className="filter-button-org popover-btn mx-2"
                style={{
                    height: '40px',
                    backgroundColor: 'white',
                }}
            >
                <img
                    src="/svgs/organization/buttons/filter.svg"
                    width={16}
                    height={16}
                    alt="filter"
                />
                Filters
            </DropdownToggle>
            <DropdownMenu
                className="shadow-sm rounded  d-flex justify-content-start py-0 my-0 px-4"
                style={{ maxHeight: '600px', overflowY: 'auto', width: 'auto' }}
            >
                <Formik initialValues={initValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue, handleSubmit }) => (
                        <Form
                            onSubmit={handleSubmit}
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '12px',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'nowrap',
                                    gap: '14px',
                                    justifyContent: 'center',
                                    alignItems: 'start',
                                    width: '100%',
                                }}
                            >
                                {renderFilters(values, setFieldValue)}
                            </div>
                            <div className="d-flex align-items-center justify-content-end w-100 sticky-modal-footer">
                                <Button
                                    className="cancel-btn-modal modals-new-btns"
                                    onClick={() => {
                                        cancelValues()
                                        toggle()
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="save-btn-modal modals-new-btns"
                                    style={{ marginLeft: '12px' }}
                                    type="submit"
                                >
                                    Save
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </DropdownMenu>
        </Dropdown>
    )
}

export default Filter
